import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73223d0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "ratings" }
const _hoisted_3 = { class: "review-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
        return _createVNode(_component_FontAwesomeIcon, {
          key: index,
          class: _normalizeClass([index<=_ctx.rate?'rating-color':'']),
          icon: _ctx.starIcon
        }, null, 8, ["class", "icon"])
      }), 64))
    ]),
    _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.totalReviews) + " Reviews", 1)
  ]))
}